import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import { Button, Stack, Typography } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers-pro";
import BalanceSheetEntityFilter from "../../balance-sheet/components/BalanceSheetEntityFilter.tsx";
import BalanceSheetPeriodPicker from "../../balance-sheet/components/BalanceSheetPeriodPicker.tsx";
import CounterpartyTypeFilter from "../../ap-ar-aging-detail/components/CounterpartyTypeFilter.tsx";
import useAgingSummaryContext from "../contexts/AgingSummaryContext.tsx";

const AgingSummaryToolbar = () => {
  const {
    period,
    onPeriodChange,
    asOfDate,
    onAsOfDateChange,
    entityOptions,
    selectedEntity,
    onEntityChange,
    counterpartyTypeOptions,
    selectedCounterpartyType,
    onCounterpartyTypeChange,
    onResetFilters,
  } = useAgingSummaryContext();

  return (
    <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", justifyContent: "space-between" }}>
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", alignItems: "center" }}>
        <BalanceSheetPeriodPicker value={period} onChange={onPeriodChange} showTodayOption />

        <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
          <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: "nowrap" }}>
            As of&nbsp;
          </Typography>
          <DesktopDatePicker
            value={asOfDate}
            onChange={(date) => date && onAsOfDateChange(date)}
            slots={{ openPickerIcon: CalendarTodayRoundedIcon }}
            slotProps={{ textField: { size: "small", sx: { width: 160 } } }}
          />
        </Stack>

        <BalanceSheetEntityFilter options={entityOptions} value={selectedEntity} onChange={onEntityChange} />
        <CounterpartyTypeFilter
          options={counterpartyTypeOptions}
          value={selectedCounterpartyType}
          onChange={onCounterpartyTypeChange}
        />
      </Stack>
      <Button
        variant="text"
        color="secondary"
        onClick={onResetFilters}
        sx={{ textTransform: "none", whiteSpace: "nowrap" }}
      >
        Reset Filter
      </Button>
    </Stack>
  );
};

export default AgingSummaryToolbar;
